import { FilteredCreditApplication } from '@applyonline/shared'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { IdentityVerificationSession } from '../../api/identity-verification-session-api'
import { useMerchantLogoWithiFinancePartnership } from '../App/hooks'
import { useDefaultConfig, useScript } from './vouched-hooks'
interface Props {
  session: IdentityVerificationSession | null
  creditApplication: FilteredCreditApplication
}

const id = 'vouched-container'

const VouchedComponent = ({ session, creditApplication }: Props) => {
  const {
    i18n: { resolvedLanguage },
  } = useTranslation()

  const languageSuffix = resolvedLanguage === 'fr' ? 'fr' : 'en'

  const scriptLoaded = useScript('https://static.vouched.id/plugin/releases/latest/index.js')

  const logoUrl = useMerchantLogoWithiFinancePartnership(languageSuffix, creditApplication)

  const { config } = useDefaultConfig(creditApplication, session, logoUrl)

  useEffect(() => {
    if (scriptLoaded && window.Vouched) {
      const vouched = window.Vouched({ ...config })
      vouched.mount(`#${id}`)
      return () => {
        vouched.unmount(`#${id}`)
      }
    }
  }, [scriptLoaded, config])

  return (
    <div
      id={id}
      style={{
        height: '100%',
      }}
    />
  )
}

export default VouchedComponent
